module.exports = __webpack_public_path__ + "img/dimensions.87de4c28.png";